import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormComponent } from './dynamic-form.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DynamicFormComponent, FileUploaderComponent, ProgressBarComponent],
  exports: [
    DynamicFormComponent,  FileUploaderComponent, ProgressBarComponent
  ]
})
export class DynamicFormModule { }
